import React, { Component } from 'react'
import gql from "graphql-tag"
import ListingFilters from '../Material/ListingFilters'
import toTitleCase from "../Functions/toTitleCase"
import { Row, Col, Input } from "reactstrap"
import { TagsQuery, RepsQuery, DriverInsuranceStatusStatus, AllRemovedReasonTypes, AllDidntTakeCarReason, LeadStatus } from "./Queries"
import RepAssignmentModal from "../Material/RepAssignmentModal"
import updateFilters from "../Functions/updateFilters"
import getFilterValuesFromQueryString from "../Functions/getFilterValuesFromQueryString"
import renderEnumToInt from "../Functions/renderEnumToInt"
import handleConfigurationChange from "../Functions/handleConfigurationChange"
import withApolloClient from "../withApolloClient"
import ConfirmationPopup from '../Material/ConfirmationPopup'

const RemoveDriverAssignmentMutation = gql`
    mutation RemoveDriverAssignment($input: RemoveDriverAssignmentInput!) {
        removeDriverAssignment(input: $input) {
            ok
            errors {
                messages
            }
        }
    }
`

class FollowupListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
            filterValues: this.props.filterValues,
            loading: false,
            error: ""
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
    }
    unAssignReps = () => {
        this.setState({ loading: true })
        let input = {
            drivers: this.props.selectedCustomers,
            assignmentCategory: "SALES",

        }
        this.props.apolloClient.mutate({
            mutation: RemoveDriverAssignmentMutation,
            variables: { input },
        }).then((result) => {
            this.toggleModal("")
            this.setState({ loading: false })
            this.props.refetchQuery()
        })
    };


    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        let filterKeys = Object.keys(filterValues)
        if (filterKeys.includes(filterName)) {
            delete filterValues[filterName]
            updateFilters({ ...this.props.filterValues }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
        }
    }

    getValueByFilterType = (filterConfigs, value) => {
        if (filterConfigs.type === "select") {
            let options = filterConfigs["options"]
            if (options && options.length > 0) {
                if (Array.isArray(value)) {
                    value = value.map(item => options.find(option => option.value === item)?.label)
                } else {
                    if (value === true) {
                        value = 'true'
                    }
                    else if (value === false) {
                        value = 'false'
                    }
                    value = options.find(option => option.value === value) && options.find(option => option.value === value).label
                }
            }
        } else if (filterConfigs.type === "boolean") {
            value = toTitleCase(value.toString())
        } else if (filterConfigs.type === "date-range")
            value = value[0].startDate && value[0].endDate ? value[0].startDate : ""
        return Array.isArray(value) ? value.join(", ") : value
    }

    getFilterConfigurations = () => {
        return [
            {
                type: "select", name: "assignedTo", title: "Assigned Reps", valueSelector: "id", labelSelector: "firstName",
                optionsQuery: RepsQuery, variables: { groups: ["Sales Team"] }, placeholder: "Filter By Assigned Reps",
                showFilter: true
            },
            { type: "select", name: "driverTags", title: "Driver Tags", optionsQuery: TagsQuery, placeholder: "Filter By Driver Tags", valueSelector: "name", labelSelector: "name", isMulti: true, showFilter: true },
            { type: "select", name: "excludeDriverTags", title: "Exclude Driver Tags", optionsQuery: TagsQuery, placeholder: "Filter By Exclude Driver Tags", valueSelector: "name", labelSelector: "name", isMulti: true, showFilter: true },
            {
                type: "select", name: "insuranceStatuses", title: "Last Insurance Status",
                optionsQuery: DriverInsuranceStatusStatus, placeholder: "Filter By Insurance Status",
                valueSelector: "name", labelSelector: "description", extractValue: true, showFilter: true, isMulti: true
            },
            {
                type: "select", name: "insuranceRemovedReasonIds", title: "Last Insurance Removed Reason",
                optionsQuery: AllRemovedReasonTypes, placeholder: "Filter By Insurance Removed Reason",
                valueSelector: "id", labelSelector: "reasonName", showFilter: true, isMulti: true
            },
            {
                type: "select", name: "didntTakeCarReasonIds", title: "Last Didnt Take Car Reasons",
                optionsQuery: AllDidntTakeCarReason, placeholder: "Filter By Didnt Take Car Reasons",
                valueSelector: "id", labelSelector: "name", showFilter: true, isMulti: true
            },
            { type: "boolean", name: "hasRented", title: "Has Rental In Past", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Rented In Past", showFilter: true },
            { type: "boolean", name: "dtacAfterRental", title: "Has Rental After DTAC", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Has Rental After DTAC", showFilter: true },
            { type: "select", name: "leadStatuses", title: "Lead Status", optionsQuery: LeadStatus, placeholder: "Filter By Lead Status", valueSelector: "name", labelSelector: "description", isMulti: true, showFilter: true },
        ]
    }

    setConfigurations = () => {
        let conf = this.getFilterConfigurations()
        let configurations = conf.filter(filter => filter['showFilter']).map(filter => {
            if (filter['optionsQuery']) {
                let options = []
                this.props.apolloClient.query({
                    query: filter.optionsQuery,
                    variables: { ...filter.variables }
                }).then(result => {
                    if (result && result.data.optionsList && result.data.optionsList.edges && result.data.optionsList.edges.length > 0) {
                        options = result.data.optionsList.edges.map(options => options.node && ({
                            value: options.node[filter.valueSelector], label: options.node[filter.labelSelector]
                        }))
                    } else if (result && result.data.optionsList && result.data.optionsList.states && result.data.optionsList.states.length > 0) {
                        options = result.data.optionsList.states.map(options => options.node ? ({ value: options.node[filter.valueSelector], label: options.node[filter.labelSelector] }) : ({ value: filter.extractValue ? renderEnumToInt(options[filter.valueSelector]) : options[filter.valueSelector], label: options[filter.labelSelector] }))
                    }
                    filter['options'] = options
                    delete filter['optionsQuery']
                })
            }
            return filter
        })
        this.setState({ configurations: configurations })
    }
    componentDidMount() {
        this.setConfigurations()
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.configurations !== prevState.configurations) {
            let urlFilterValues = getFilterValuesFromQueryString(this.props.location.search, this.state.configurations)
            handleConfigurationChange(prevState.configurations, this.state.configurations, urlFilterValues, this.props.setFilterValues, this.props.navigate, this.props.location, this.props.defaultFilters, updateFilters)
        }
    }

    render() {
        return (
            <Row className="pb-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters open={this.state.openModal === "viewFilters"} handleClose={() => this.toggleModal("")}
                        target="viewFilters" filterValues={this.props.filterValues} setFilterValues={(filters => updateFilters(filters, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues))}
                        filters={this.state.configurations}
                    />}
                {this.state.openModal === "RepAssignmentModal" && <RepAssignmentModal
                    open={this.state.openModal === "RepAssignmentModal"}
                    title={"Assign " + this.props.selectedCustomers.length + " Selected Drivers to Reps"}
                    drivers={this.props.selectedCustomers}
                    handleClose={() => this.toggleModal(false)}
                    refetchDrivers={this.props.refetchQuery}
                    group={"Sales Team"}
                    assignmentCategory={["SALES"]}
                />}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={8} className="text-right mt-2">
                    {this.props.selectedCustomers && this.props.selectedCustomers.length > 0 && this.props.selectedCustomers.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("unAssignReps")}>
                            Unassign Reps | <i className="fa fa-minus" aria-hidden="true"></i>
                            {this.state.openModal === "unAssignReps" &&
                                <ConfirmationPopup
                                    open={this.state.openModal === "unAssignReps"}
                                    message={"Are you sure you want to un-assign " + (this.props.selectedCustomers?.length) + " reps?"}
                                    loading={this.state.loading}
                                    handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                                    action={"Un-assign"}
                                    confirmAction={() => this.unAssignReps()}
                                    color="primary"
                                    error={this.state.error ? this.state.error : ""}
                                />
                            }
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a className="driver-list-button" onClick={() => this.toggleModal("RepAssignmentModal")}>
                            Assign Reps | <i className="fa fa-plus" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("viewFilters")}>
                        Apply Filters | <i className="fa fa-filter" aria-hidden="true"></i> {this.props.filterValues && Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).length || ""}
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Col>
                <Col xs={12} className="mt-2">
                    {Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key) && this.state.configurations.find(setting => setting.name === key).showFilter).map(key =>
                        <span className="search-filter-preview">
                            <span>
                                <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                {this.state.configurations.find(setting => setting.name === key).title}
                            </span>
                            {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                        </span>
                    )}
                    {this.props.selectedCustomers && this.props.selectedCustomers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedCustomers}></i> &nbsp;&nbsp; Selected Customers</span>
                        {this.props.selectedCustomers.length}
                    </span>}
                </Col>
            </Row >
        )
    }
}

export default (withApolloClient(FollowupListHeader))